import { namespace } from "@core/contants/constant";
import table from "@store/reducers/pattern/table";

export const name = `${namespace}_voting_finish`;

export default table(name);
